export const buildUserUpdatePayload = (values, id) =>
  Object.entries(values || {}).reduce(
    (payload, [fieldName, fieldValue]) => {
      if (fieldValue === null || fieldValue === undefined) {
        return payload;
      }

      if (typeof fieldValue === "string" && fieldValue.trim() === "") {
        return payload;
      }

      payload[fieldName] = fieldValue;
      return payload;
    },
    { id }
  );
